import { render } from "./PlayerDisplay.vue?vue&type=template&id=62aa3470&scoped=true"
import script from "./PlayerDisplay.vue?vue&type=script&lang=js"
export * from "./PlayerDisplay.vue?vue&type=script&lang=js"

import "./PlayerDisplay.vue?vue&type=style&index=0&id=62aa3470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62aa3470"]])

export default __exports__